import Typography from '@mui/material/Typography'
import {HealthConditionSubTitle} from '../HealthCondition/HealthConditionStyle'
import {TemporaryToggle} from '../../UserManagement/UserManagementStyle'
import PropTypes from 'prop-types'
import {Box, Grid} from '@mui/material'
import {ChatbotGrid, ToggleStack} from '../chatbot/ChatbotCopyStyle'

const ExportPermissionComponent = ({selectedExportToggle, setselectedExportToggle}) => {
  const setselectedTogglefunction = () => {
    setselectedExportToggle([1 - selectedExportToggle[0]])
  }

  return (
    <Box tabIndex={0} aria-label='export'>
      <ChatbotGrid container spacing={2}>
        <Grid item xs={12} md={6}>
          <HealthConditionSubTitle>
            This will allow exporting of data from the dashboard based on filter selections. This includes both map
            images and .csv data files.
          </HealthConditionSubTitle>
        </Grid>
        <Grid item xs={12} md={6}>
          <ToggleStack>
            <Typography>Off</Typography>
            <TemporaryToggle
              checked={selectedExportToggle?.length > 0 ? selectedExportToggle[0] : false}
              onChange={setselectedTogglefunction}
              aria-label='Export Toggle Button'
            />
            <Typography>On</Typography>
          </ToggleStack>
        </Grid>
      </ChatbotGrid>
    </Box>
  )
}

ExportPermissionComponent.propTypes = {
  setselectedExportToggle: PropTypes.func,
  selectedExportToggle: PropTypes.array
}

export default ExportPermissionComponent
